export default "__VITE_ASSET__RFsdCgpp__"